module.exports = {
    devServer: {
        proxy: 'http://localhost:15383'
    },
    filenameHashing: false,
    chainWebpack: config => {
        config.externals({
            'jquery': 'jQuery',
            'jdr': 'jdr',
            'aitl': 'aitl',
            'apiClientRef': 'apiClient',
            'uiClientRef': 'uiClient',
            'intLangRef':'intLang'
        })
    },
    runtimeCompiler: true,
    //outputDir: '../../NetcoreApi/wwwroot/dist',//process.env.outputDir,
    publicPath: "./",
    pages: {
        macbackend: {
            entry: 'src/dashboard.js',
            template: 'public/templ.dashboard.mac.html',
            filename: 'dashboard-mac.html',
            //filename: 'index.html',
        },
        macfrontend: {
            entry: 'src/main.js',
            template: 'public/templ.shop.mac.html',
            //filename: 'shop-mac.html',
            filename: 'index.html',
        },
        shop: {
            entry: 'src/main.js',
            template: 'public/templ.shop.html',
            filename: 'shop.html',
        },
        dashboard: {
            entry: 'src/dashboard.js',
            template: 'public/templ.dashboard.html',
            filename:'dashboard.html'
        },
        editpost: {
            entry: 'src/post.js',
            template: 'public/empty.html',
            filename: 'post.html'
        },
        unitTest: {
            entry: 'src/unitTest.js',
            template: 'public/templ.unitTest.html',
            filename: 'unitTest.html'
        }
    }
}